let navigate = null;

export const setNavigate = (nav) => {
  navigate = nav;
};

export const getNavigate = () => {
  if (!navigate) {

    return () => {}; 
  }
  return navigate;
};
